// Module
var code = `<sub-header header="'Areas'" tab="true">
  <button command-access="CreateArea"
            class="btn btn-primary"
            type="button"
            ng-click="\$ctrl.create()">
      Add new
    </button>
  </sub-header>
  <form-section form-title="'Area structure'">
    <div class="tree">
      <ul class="root">
        <li ng-repeat="item in \$ctrl.areas | orderBy:'name'" ng-include="'areas__tree-template'">
        </li>
      </ul>
    </div>
  </form-section>

  <form-section form-title="'Unassigned branches'"
                class="unassigned"
                ng-if="\$ctrl.unassignedBranches && \$ctrl.unassignedBranches.length > 0">
    <ul>
      <li ng-repeat="branch in \$ctrl.unassignedBranches | orderBy:'name'">{{ branch.name }}</li>
    </ul>
  </form-section>


${"<" + "script"} type="text/ng-template" id="areas__tree-template">
    <span class="list-row" ng-class="{'area': item.isArea}">{{item.name}}
      <span>
      <button command-access="UpdateArea"
              ng-if="item.isArea"
              type="button" class="btn btn-small btn-warning"
              ng-click="\$ctrl.edit(item.id)">Edit</button>
      <button command-access="DeleteArea"
              ng-if="item.isArea"
              type="button" class="btn btn-small btn-danger"
              ng-click="\$ctrl.delete(item)">Delete</button>
      </span>
    </span>
    <ul ng-if="item.branches">
      <li ng-repeat="item in item.branches | orderBy:'name'" ng-include="'areas__tree-template'">
      </li>
    </ul>
    <ul ng-if="item.children">
      <li ng-repeat="item in item.children | orderBy:'name'" ng-include="'areas__tree-template'">
      </li>
    </ul>
${"<" + "/script"}>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/areas/area/areas.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;